import { HelpCircle } from 'lucide-react'
import { AnimatePresence, motion } from 'motion/react'
import { useTranslation } from 'react-i18next'

import { env } from '@/env'

const ZENDESK_HELP_URL = 'https://b2b-reservas.zendesk.com/hc/pt-br'

interface ZendeskHelpButtonProps {
  isOpen: boolean
}

export function ZendeskHelpButton({ isOpen }: ZendeskHelpButtonProps) {
  const { t } = useTranslation('common')

  if (env.VITE_ENV !== 'production') return null

  function handleClick() {
    window.open(ZENDESK_HELP_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex gap-2 items-center justify-start w-full h-10 text-white bg-transparent hover:bg-white/10 duration-200 border border-white/50 rounded-md"
    >
      <HelpCircle className="size-4 shrink-0 ml-2.5" />

      <AnimatePresence>
        {isOpen && (
          <motion.span
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0, transition: { duration: 0.3 } }}
            exit={{ x: -50, opacity: 0, transition: { duration: 0.3 } }}
            className="text-white text-nowrap"
          >
            {t('--actions-help-center')}
          </motion.span>
        )}
      </AnimatePresence>
    </button>
  )
}
